/* ══════════════════════════════════════════════════
   Holistic Vitalis — Partnership Homepage JS
   ══════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Scroll fade-up observer ── */
  function initFadeUp() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.hv-home-fade-up').forEach(function (el) {
        el.classList.add('hv-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hv-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.hv-home-fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Stat counter animation ── */
  function animateCounters() {
    var counters = document.querySelectorAll('[data-hv-count]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);

        var target = parseInt(el.getAttribute('data-hv-count'), 10);
        var suffix = el.getAttribute('data-hv-suffix') || '';
        var prefix = el.getAttribute('data-hv-prefix') || '';

        if (isNaN(target)) {
          el.textContent = prefix + el.getAttribute('data-hv-count') + suffix;
          return;
        }

        var duration = 2000;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(eased * target);
          el.textContent = prefix + current + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ── Form handler ── */
  function initForm() {
    var form = document.getElementById('hv-home-apply-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var nameInput = form.querySelector('[name="name"]');
      var emailInput = form.querySelector('[name="email"]');
      var programInput = form.querySelector('input[name="program"]:checked');
      var submitBtn = form.querySelector('.hv-home-form__submit');

      if (!programInput) return;

      var name = nameInput.value.trim();
      var email = emailInput.value.trim();
      var program = programInput.value;

      submitBtn.textContent = 'SUBMITTING...';
      submitBtn.disabled = true;

      var webhookUrl = form.getAttribute('data-webhook');
      if (!webhookUrl) webhookUrl = 'https://services.leadconnectorhq.com/hooks/cuJ3zI8IC0m4JKc9x0SU/webhook-trigger/partnership-apply';

      var payload = {
        name: name,
        email: email,
        program: program,
        source: 'partners-homepage',
        timestamp: new Date().toISOString()
      };

      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'no-cors'
      }).then(function () {
        showSuccess(form, name, email, program);
      }).catch(function () {
        showSuccess(form, name, email, program);
      });
    });
  }

  function showSuccess(form, name, email, program) {
    var programLabel = program.replace(/-/g, ' ');
    form.innerHTML =
      '<div style="text-align:center;padding:48px 20px;">' +
        '<div style="width:60px;height:60px;background:rgba(201,169,78,0.15);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 24px;">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A94E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        '</div>' +
        '<h3 style="font-family:Pathway Gothic One,sans-serif;font-size:1.8rem;text-transform:uppercase;letter-spacing:3px;margin-bottom:12px;color:#ffffff;">THANK YOU, ' + name.toUpperCase() + '</h3>' +
        '<p style="font-family:Montserrat,sans-serif;color:rgba(255,255,255,0.65);font-size:0.95rem;line-height:1.7;">We received your interest in the <strong style="color:#C9A94E;">' + programLabel + '</strong> program. Our team will reach out to <strong style="color:rgba(255,255,255,0.85);">' + email + '</strong> within 48 hours.</p>' +
      '</div>';
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFadeUp();
      animateCounters();
      initForm();
    });
  } else {
    initFadeUp();
    animateCounters();
    initForm();
  }
})();
